var styles = {
  "FormattingList": "_FormattingList_fpsrb_34",
  "Option": "_Option_fpsrb_40",
  "OptionButton": "_OptionButton_fpsrb_47",
  "OptionButton-selected": "_OptionButton-selected_fpsrb_98",
  "elementP": "_elementP_fpsrb_102",
  "elementH1": "_elementH1_fpsrb_108",
  "elementH2": "_elementH2_fpsrb_114",
  "elementH3": "_elementH3_fpsrb_120",
  "elementH4": "_elementH4_fpsrb_126",
  "elementH5": "_elementH5_fpsrb_132",
  "elementH6": "_elementH6_fpsrb_138",
  "elementBlockquote": "_elementBlockquote_fpsrb_144",
  "SelectedCheck": "_SelectedCheck_fpsrb_159"
};

export { styles as default };
